import { productLinesStyles as styles } from "@hardware/Overrides/Widgets/BrandDetails/BrandDetailsProductLines";
import { colorStrings } from "@hardware/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.productLineItemRow = {
    ...styles.productLineItemRow,
    width: [6, 6, 4, 3, 3],
};

styles.productLineNameLinkImg = {
    ...styles.productLineNameLinkImg,
    css: css`
        display: block;
        width: 100%;
        background-color: transparent;
    `,
};

styles.productLineName = {
    ...styles.productLineName,
    css: css`
        ${styles.productLineName?.css}
        margin-block-start: 5px;
    `,
};

styles.productLineImageItem = {
    ...styles.productLineImageItem,
    css: css`
        ${styles.productLineImageItem?.css}
        justify-content: center;
        background-color: ${getColor(colorStrings.commonGlobalWhite)};
    `,
};

styles.productLineImage = {
    css: css`
        background-color: transparent;
        img {
            width: 100%;
            aspect-ratio: 4 / 3;
            object-fit: contain;
            height: 100%;
        }
    `,
};
